import { ModuleId } from '@xmiles/holopix-types';

/**
 * A3（Qwen-image）一键成稿 module 常量（对齐 @xmiles/holopix-types ModuleId）。
 */
export const MODULE_ID_EXPLORE_A3 = ModuleId.ExploreA3;
export const MODULE_ID_CANVAS_DRAFT_A3 = ModuleId.CanvasDraftA3;

/** AI 创作一键成稿族：原 Explore + A3 */
export const EXPLORE_FAMILY_IDS = [ModuleId.Explore, ModuleId.ExploreA3] as const;

/** 自由画布一键成稿族：原 CanvasDraft + A3 */
export const CANVAS_DRAFT_FAMILY_IDS = [ModuleId.CanvasDraft, ModuleId.CanvasDraftA3] as const;
